import React, { useRef } from "react";
import { gsap, useGSAP, prefersReducedMotion } from "../../lib/gsap";

/**
 * Type arrives by interpolating Archivo's variable axes: the words start
 * narrow and light, then widen and thicken into their set weight. Because the
 * axes are continuous there is no transform and no fade — the letterforms
 * themselves resolve, which is a reveal only a variable font can do.
 */
const AxisReveal = ({
  children,
  as: Tag = "h2",
  className = "",
  wdth = 100,
  wght = 600,
  fromWdth = 74,
  fromWght = 260,
  duration = 1.25,
  delay = 0,
  start = "top 85%",
  play = true,
  ...rest
}) => {
  const scope = useRef(null);

  useGSAP(
    () => {
      const el = scope.current;
      if (!el) return undefined;

      const set = (w, g) => {
        el.style.fontVariationSettings = `'wdth' ${w.toFixed(2)}, 'wght' ${g.toFixed(0)}`;
      };

      if (!play) {
        set(wdth, wght);
        return undefined;
      }

      if (prefersReducedMotion()) {
        set(wdth, wght);
        return undefined;
      }

      const axis = { w: fromWdth, g: fromWght };
      set(axis.w, axis.g);

      const tween = gsap.to(axis, {
        w: wdth,
        g: wght,
        duration,
        delay,
        ease: "power3.inOut",
        onUpdate: () => set(axis.w, axis.g),
        scrollTrigger: { trigger: el, start, once: true },
      });

      return () => {
        tween.scrollTrigger?.kill();
        tween.kill();
      };
    },
    { scope, dependencies: [play, wdth, wght] }
  );

  return (
    <Tag ref={scope} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default AxisReveal;
